











































































































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { FinalDocument as IFinalDocument } from "@/api/models/final-document";
import { FinalDocumentEdit as IFinalDocumentEdit } from "@/api/models/final-document-edit";
import { User as IUser } from "@/api/models/user";
import { CourseDocumentInfo as ICourseDocumentInfo } from "@/api/models/course-document-info";
import api, { courseApi } from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import { Student as IStudent } from "@/api-v2/course/models";
import { generatePdf } from "@/utils/files-helper";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import store from "@/store";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import UserStudentFiles from "@/components/user/UserStudentFiles.vue";
import { studentDocumentModule } from "@/plugins/modules-detect";

@Component({
  components: {
    UserStudentFiles,
    CustomButton,
    Modal,
    DocTemplateGenerateV2,
    DocumentArchiveButton,
    EntityFiles,
    TextField,
    CBlock,
    CBreadCrumbs
  }
})
export default class FinalDocument extends Vue {
  finalDocument!: IFinalDocument;
  resourceType!: string;
  user!: IUser;
  documentType!: string;
  isLoadingFiles: boolean = false;
  student!: IStudent;
  modalShow: boolean = false;
  buttonType: string = "passive";

  data() {
    return {
      student: undefined,
      documentType: undefined,
      finalDocument: undefined,
      resourceType: undefined,
      user: undefined,
      course: undefined,
      resourceName: undefined
    };
  }

  get generateFileName() {
    return `${this.user.fullName}-${this.finalDocument.number}`;
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  get isStudentDocumentModule() {
    return studentDocumentModule();
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: IFinalDocumentEdit = {
      protocolId: this.finalDocument.protocol.id,
      internship: this.finalDocument.internship,
      graduateWork: this.finalDocument.graduateWork,
      expiration: this.finalDocument.expiration,
      assignedQualificationRank: this.finalDocument.assignedQualificationRank,
      formOfEducation: this.finalDocument.formOfEducation,
      sourceOfFinance: this.finalDocument.sourceOfFinance,
      educationalRelations: this.finalDocument.educationalRelations,
      certificateSeries: this.finalDocument.certificateSeries,
      series: this.finalDocument.series,
      listenerId: this.finalDocument.listenerId
        ? this.finalDocument.listenerId
        : "",
      signedAt: this.finalDocument.signedAt,
      fileIds:
        this.finalDocument.files && fromDocTemplate
          ? [...this.finalDocument.files.map((el: any) => el.id), ...files]
          : [...files],
      number: this.finalDocument.number,
      issuedAt: this.finalDocument.issuedAt,
      status: this.finalDocument.status,
      registerNumber: this.finalDocument.registerNumber,
      educationDocument:
        this.finalDocument.status === 0
          ? this.finalDocument.educationDocument
          : undefined,
      originalNumber:
        this.finalDocument.status === 0
          ? this.finalDocument.originalNumber
          : undefined,
      originalRegisterNumber:
        this.finalDocument.status === 0
          ? this.finalDocument.originalRegisterNumber
          : undefined,
      originalIssuedAt:
        this.finalDocument.status === 0
          ? this.finalDocument.originalIssuedAt
          : undefined,
      originalSeries:
        this.finalDocument.status === 0
          ? this.finalDocument.originalSeries
          : undefined,
      recipientName:
        this.finalDocument.status === 0
          ? this.finalDocument.recipientName
          : undefined,
      recipientMiddleName:
        this.finalDocument.status === 0
          ? this.finalDocument.recipientMiddleName
          : undefined,
      recipientLastName:
        this.finalDocument.status === 0
          ? this.finalDocument.recipientLastName
          : undefined,
      documentNumberToChange:
        this.finalDocument.status === 0
          ? this.finalDocument.documentNumberToChange
          : undefined,
      confirmOfLoss:
        this.finalDocument.status === 0
          ? this.finalDocument.confirmOfLoss
          : undefined,
      confirmOfExchange:
        this.finalDocument.status === 0
          ? this.finalDocument.confirmOfExchange
          : undefined,
      destructionConfirm:
        this.finalDocument.status === 0
          ? this.finalDocument.destructionConfirm
          : undefined
    };

    this.isLoadingFiles = true;

    api.FinalDocumentApi.edit(this.finalDocument.id, params)
      .then((res: { data: IFinalDocument }) => {
        this.finalDocument = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  get status() {
    return !!this.finalDocument?.signedAt;
  }

  get formOfEducation() {
    switch (this.finalDocument.formOfEducation) {
      case 0: {
        return `${this.$tc(this.$translate.FulltimeStudy)}`;
      }
      case 1: {
        return `${this.$tc(this.$translate.FulltimeparttimeStudy)}`;
      }
      case 2: {
        return `${this.$tc(this.$translate.ParttimeStudy)}`;
      }
      default: {
        return `${this.$tc(this.$translate.NotSelected)}`;
      }
    }
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "finalDocumentList" },
        label: `${this.$tc(this.$translate.FinalDocuments)}`
      },
      {
        label: this.finalDocument.number
      }
    ];
  }

  get statusOfEducation() {
    switch (this.finalDocument.status) {
      case 0: {
        return `${this.$tc(this.$translate.Duplicate)}`;
      }
      case 1: {
        return `${this.$tc(this.$translate.Original)}`;
      }
      default: {
        return "any";
      }
    }
  }

  get sourceOfFinance() {
    switch (this.finalDocument.sourceOfFinance) {
      case 0: {
        return `${this.$tc(this.$translate.TheFederalBudget)}`;
      }
      case 1: {
        return `${this.$tc(this.$translate.RegionalBudget)}`;
      }
      case 2: {
        return `${this.$tc(this.$translate.LocalTraining)}`;
      }
      case 3: {
        return `${this.$tc(this.$translate.PaidEducation)}`;
      }
      default: {
        return `${this.$tc(this.$translate.NotSelected)}`;
      }
    }
  }

  get educationalRelations() {
    switch (this.finalDocument.educationalRelations) {
      case 0: {
        return `${this.$tc(this.$translate.InEducationalOrganization)}`;
      }
      case 1: {
        return `${this.$tc(this.$translate.NotInEducationalOrganization)}`;
      }
      default: {
        return `${this.$tc(this.$translate.NotSelected)}`;
      }
    }
  }

  getFinalDocument() {
    api.FinalDocumentApi.get(this.$route.params.id).then(
      (res: { data: IFinalDocument }) => {
        this.finalDocument = res.data;
        this.getDocumentInfoFn();
        document.title = `${this.$t(this.$translate.FinalDocument)} ${
          this.finalDocument.number
        } | ${this.companyTitle}`;
        if (
          this.finalDocument.protocol &&
          this.finalDocument.protocol.listeners?.length &&
          this.finalDocument.protocol.listeners[0].version === "v2" &&
          this.finalDocument.listenerId
        ) {
          courseApi.CourseRegistration.getCourseRegistration(
            this.finalDocument.listenerId
          ).then(({ data }) => {
            this.student = data.student;
          });
        }
      }
    );
  }

  get companyTitle() {
    return store.getters.selectedCompany.title;
  }

  getDocumentInfoFn() {
    api.CourseApi.getDocumentInfo(this.finalDocument.protocol.course.id).then(
      (res: { data: ICourseDocumentInfo }) => {
        if (res.data.documentType)
          this.documentType = res.data.documentType.title;
      }
    );
  }

  getUserById() {
    if (
      this.finalDocument &&
      this.finalDocument.listenerId &&
      this.finalDocument.protocol.listeners
    ) {
      [this.user] = this.finalDocument.protocol.listeners
        .filter(el => el.id === this.finalDocument.listenerId)
        .map(el => el.user);
    }
  }

  @Watch("finalDocument")
  updateFinalDocument() {
    this.getUserById();
  }

  get confirmOfLoss() {
    if (this.finalDocument.confirmOfLoss === 0) {
      return `${this.$tc(this.$translate.Not)}`;
    } else if (this.finalDocument.confirmOfLoss === 1) {
      return `${this.$tc(
        this.$translate.ReferenceFromTheDepartmentOfInternalAffairs
      )}`;
    } else if (this.finalDocument.confirmOfLoss === 2) {
      return `${this.$tc(this.$translate.ReferenceFromTheFireAuthorities)}`;
    } else if (this.finalDocument.confirmOfLoss === 3) {
      return `${this.$tc(this.$translate.AnnouncementInTheNewspaper)}`;
    } else {
      return `${this.$tc(this.$translate.Other)}`;
    }
  }

  get confirmOfExchange() {
    switch (this.finalDocument.confirmOfExchange) {
      case 0:
        return `${this.$tc(this.$translate.Not)}`;
      case 1:
        return `${this.$tc(this.$translate.ExchangeDueToDamage)}`;
      default:
        return `${this.$tc(
          this.$translate.ExchangeDueToFalseInformationProviding
        )}`;
    }
  }

  backToList() {
    this.$router.push({
      name: "finalDocumentList"
    });
  }

  disableDocDownload() {
    api.FinalDocumentApi.resetUnloadFisFrdo([this.finalDocument.id]).then(
      res => {
        if (res) {
          this.modalShow = false;
          this.$bvToast.toast(
            this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
            {
              variant: "success",
              title: this.$tc(this.$translate.Successful)
            }
          );
        } else {
          this.$bvToast.toast(`${this.$tc(this.$translate.Error)}`, {
            variant: "danger",
            title: `${this.$tc(this.$translate.Error)}`
          });
        }
      }
    );
  }

  mounted() {
    this.getFinalDocument();
  }
}
